import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTenant } from '../context/TenantContext';
import { useClient } from '../context/ClientContext';
import Loader from '../components/ui/loader.jsx';

const SPIN_REDIRECT_KEY = 'spin_email_redirect';

const Verify = () => {
  const navigate = useNavigate();
  const { tenant } = useTenant();
  const { client } = useClient();
  const hasRedirected = useRef(false);

  useEffect(() => {
    if (!tenant?.tenanturlname || hasRedirected.current) return;
    hasRedirected.current = true;

    const tenanturl = tenant.tenanturlname;

    if (client) {
      // Already logged in — go straight to cashback tab
      navigate(`/${tenanturl}/myprofile?tab=cashback`, { replace: true });
    } else {
      // Not logged in — set flag so SignIn can redirect after login
      try {
        sessionStorage.setItem(SPIN_REDIRECT_KEY, '1');
      } catch {
        /* storage unavailable */
      }
      navigate(`/${tenanturl}/signin`, { replace: true });
    }
  }, [tenant?.tenanturlname, client, navigate]);

  return <Loader fullscreen label="Loading..." size="xl" />;
};

export default Verify;
